// Route definitions only; the schemas they refer to stay out of the web bundle.
import { defineRoute } from './route.ts';
import type { clientErrorBody, healthResponse, noContent, versionResponse } from './system.ts';

export const healthLive = defineRoute<{ response: typeof healthResponse }>()({ method: 'GET', path: '/api/health/live' });
export const healthReady = defineRoute<{ response: typeof healthResponse }>()({ method: 'GET', path: '/api/health/ready' });
export const getVersion = defineRoute<{ response: typeof versionResponse }>()({ method: 'GET', path: '/api/version' });
export const postClientError = defineRoute<{ body: typeof clientErrorBody; response: typeof noContent }>()({
  method: 'POST',
  path: '/api/client-errors',
  status: 204,
});
